module.exports = __webpack_public_path__ + "media/yir-short_optimized.d5590070.mp4";